/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LastVisitResponse } from '../../models/last-visit-response';

export interface MembersLastVisitPut$Params {}

export function membersLastVisitPut(
  http: HttpClient,
  rootUrl: string,
  params?: MembersLastVisitPut$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<LastVisitResponse>> {
  const rb = new RequestBuilder(rootUrl, membersLastVisitPut.PATH, 'put');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LastVisitResponse>;
      }),
    );
}

membersLastVisitPut.PATH = '/members/last-visit';
